export var SENTRY_RELEASE = "f418e374f4549bbf9ffda114b05c3638a0d3cfed";
